import { isEY } from "../cv_templates/ey/helpers";
import { useLocalExportBuildEYPptx } from "../cv_templates/ey/pptx/local_export_build_ey_pptx";
import { EYPptxPreview } from "../cv_templates/ey/pptx/preview/ey_pptx_preview";
import { localExportBuildKpmgAuPptx } from "../cv_templates/kpmg/au/pptx";
import { KpmgAuPptxPreview } from "../cv_templates/kpmg/au/pptx/preview";
import { KPMG_TEMPLATES } from "../cv_templates/kpmg/constants";
import { isKPMGAU, isKPMGCAFrench } from "../cv_templates/kpmg/helpers";
import localExportBuildKpmgPptx from "../cv_templates/kpmg/pptx/local_export_build_kpmg_pptx";
import KpmgPptxPreview from "../cv_templates/kpmg/pptx/preview/kpmg_pptx_preview";
import localExportBuildPptx from "../local_export_build_pptx";
import PptxPreview from "../parts/pptx_preview";

export const getLocalExportBuildPptx = (templateKey) => {
  if (KPMG_TEMPLATES.includes(templateKey)) {
    return isKPMGAU(templateKey) ? localExportBuildKpmgAuPptx : localExportBuildKpmgPptx;
  } else if (isEY(templateKey)) {
    return useLocalExportBuildEYPptx;
  } else {
    return localExportBuildPptx;
  }
};

export const getPptxPreviewComponent = (templateKey) => {
  if (KPMG_TEMPLATES.includes(templateKey)) {
    return isKPMGAU(templateKey) ? KpmgAuPptxPreview : KpmgPptxPreview;
  } else if (isEY(templateKey)) {
    return EYPptxPreview;
  } else {
    return PptxPreview;
  }
};

export const getTranslationKey = (templateKey) => {
  if (isEY(templateKey)) {
    return "eyPptx";
  }
  if (isKPMGAU(templateKey)) {
    return "kpmgAuPptx";
  }
  if (isKPMGCAFrench(templateKey)) {
    return "kpmgFrPptx";
  }
  return "kpmgPptx";
};
